<template>
<div class="service_area_section">
    <div class="container">
      <div class="row">
        <div class="col-12" v-for="single_service in get_list_service_by_categ.services" :key="single_service.id">
            <div class="service_single">
                <div class="row">
                    <div class="col-md-6">
                        <div v-if="single_service.image" class="img_service" :style="`background-image:url('${single_service.image.url}')`"></div>
                    </div>
                    <div class="col-md-6">
                        <div class="text_service list_inner">
                             <h1 class="t2">{{single_service.title}}</h1>
                             <div class="description" v-html="single_service.full_desc"></div>
                    <div class="flex_price_list">
                        <div class="single_price" v-for="carTypePrice in single_service.vehicle_types_price" :key="carTypePrice.id">
                            <div class="car_type">{{carTypePrice.vehicle_type}}</div>
                            <div class="price_type">{{carTypePrice.total.toFixed(0)}},-</div>
                        </div>
                    </div>
                    <template v-if="single_service.link_external || single_service.link_internal">
                        <template v-if="single_service.link_external!=null">
                            <a class="more" :href="single_service.link_external">{{single_service.short_desc}} <i class='bx bxs-right-arrow'></i></a>
                        </template>
                        <template v-else>
                            <router-link class="more" :to="single_service.link_internal">{{single_service.short_desc}} <i class='bx bxs-right-arrow'></i></router-link>
                        </template>
                    </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "serviceArea",
       computed:{
    ...mapGetters({
        get_list_service_by_categ:'get_list_service_by_categ',
    })
  },
    methods:{
    ...mapActions({
       list_service_by_categ_api:'list_service_by_categ_api',
    }),
    },
    mounted(){
        this.list_service_by_categ_api(this.$route.params.id);
    }
}
</script>
<style lang="scss" scoped>
.service_area_section{
    margin-top: 80px;
}
.service_single{
    margin-bottom: 100px;
}
.img_service{
        background-position: top left;
    background-repeat: no-repeat;
    background-size: 100% auto;
    height: 100%;
    width: 100%;
    min-height: 300px;
}
.flex_price_list{
        display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    padding: 2px 0px;
    .single_price{
        font-family: 'Roboto', sans-serif;
       display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1px 0px;
    font-size: 19px;
    margin-bottom: 0.4rem;
    font-weight: 500;
    }
}
ul.list li {
    margin-bottom: 0.1rem;
}
h1.t2{
    margin-top: 0;
}
a.more{
    padding-bottom: 10px;
}
@media(max-width:767px){
    .service_area_section{
    margin-top: 30px;
}
.img_service {
    background-position: top left;
    background-repeat: no-repeat;
    background-size: cover;
    height: 300px;
    width: 100%;
    margin-bottom: 30px;
}
}
</style>